import { render, staticRenderFns } from "./ProductNameForm.vue?vue&type=template&id=6cfa482c&"
import script from "./ProductNameForm.vue?vue&type=script&lang=js&"
export * from "./ProductNameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports